import { SanityKeyed, ImageAndIngredients as ImageAndIngredientsProps } from 'types/studio/studio';
import clsx from 'clsx';
import { Col, Row, Container, Typography, CheckmarkIcon } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import styles from './ImageAndIngredientsMobile.module.scss';

const ImageAndIngredientsMobile = (
  props: SanityKeyed<ImageAndIngredientsProps> & { visibleOnPageLoad: boolean }
) => {
  const {
    _key: key,
    variation,
    headline,
    text,
    textBold,
    imageAndIngredientsImage,
    ingredientsTitle,
    ingredientsItems,
    showCheckmark,
    padding,
    visibleOnPageLoad
  } = props;
  return (
    <div className={clsx(styles.root, getSectionPaddingClasses(styles, padding))} id={key}>
      <Container narrow>
        <Row className={styles.row}>
          <div className={styles.headingBlock}>
            {headline && (
              <Typography
                variant="headlineSans"
                size="2"
                component="h2"
                color="black-new"
                noPadding
                className={clsx(variation !== '2' && styles.headline)}>
                {headline}
              </Typography>
            )}
            {text && (
              <Typography
                variant="portalText"
                size="1"
                component="div"
                color="black-new"
                noPadding
                className={styles.text}>
                <CustomPortableText addAccessibility value={text} />
              </Typography>
            )}
            {textBold && (
              <Typography
                variant="portalText"
                size="1"
                component="div"
                color="black-new"
                noPadding
                className={styles.textBold}>
                <CustomPortableText value={textBold} />
              </Typography>
            )}
            {ingredientsTitle && (
              <>
                <Typography
                  variant="bodyMono"
                  size="2"
                  color="black-new"
                  className={styles.ingredientsTitle}>
                  {ingredientsTitle}
                </Typography>
                <div className={styles.divider} />
              </>
            )}
          </div>
          <div className={styles.imageListWrapper}>
            <Col
              span={6}
              noGutter
              className={clsx(styles.imageCol, variation === '2' && styles.imageCol2)}>
              {imageAndIngredientsImage.image && (
                <StudioBaseImageV2
                  className={styles.imageCont}
                  childClassName={styles.image}
                  image={imageAndIngredientsImage.image}
                  mobileImage={imageAndIngredientsImage.mobileImage}
                  withMobileImage={imageAndIngredientsImage.withMobileImage}
                  tabletImage={imageAndIngredientsImage.tabletImage}
                  eagerLoading={visibleOnPageLoad}
                />
              )}
            </Col>
            <Col
              span={{ s: { value: 6, wide: true } }}
              className={clsx(styles.listCol, variation === '2' && styles.listCol2)}>
              <ul className={styles.ingredientsList}>
                {ingredientsItems.map((item) => (
                  <li
                    key={item}
                    className={clsx(
                      styles.ingredientsItem,
                      variation === '2' ? styles.ingredientsItem2 : ''
                    )}>
                    {showCheckmark && (
                      <div className={styles.checkmark}>
                        <CheckmarkIcon size={14} strokeWidth={2} />
                      </div>
                    )}
                    <Typography
                      noPadding
                      variant={variation === '2' ? 'bodyMono' : 'body'}
                      size="3"
                      color="black-new"
                      className={styles.ingredientsItemText}>
                      {item}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Col>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default ImageAndIngredientsMobile;
